<h5>Comments</h5>
<form class="fullwidth" [formGroup]="commentForm" novalidate>

  <div *ngIf="!commentsLoading">
    <div *ngFor="let case of commentData">
      <div class="user">
        <img class="avatar" src="assets/images/avatars/profile.jpg">
      </div>
      <div style="margin-bottom: 20px;">
        <span style="color: #1F93C7;font-weight: bold;font-size: 14px;">{{ userSubs[case.user_id].firstName }}
          {{ userSubs[case.user_id].lastName }}</span>&nbsp;
        <span style="font-size: 12px;">{{ formatTime(case.commented_at) }}</span>
        <br />
        <span style="font-size: 13px;">{{ case.message }}</span>
      </div>
      <!-- <hr> -->
    </div>
  </div>

  <span *ngIf="commentsLoading">
    Comments Loading...
  </span>

  <div class="addComment" *ngIf="!isAddComment" style="max-height: 40px">
    <input matInput placeholder="Leave a comment" (click)="isAddComment = !isAddComment" readonly>
  </div>
  <div *ngIf="isAddComment" class="addComment" style="min-height: 80px">
    <textarea matInput [eguardAutofocus] on-focusout="isAddComment" placeholder="Leave a comment"
      formControlName="comment" name="comment"></textarea>
  </div>
  <br>
  <button *ngIf="isAddComment" class="alignment" mat-raised-button [class.loading]="isLoading"
    style="text-transform: uppercase" [disabled]="commentsLoading || isLoading" (click)="addComment()" color="accent">
    <div class="spinner"></div>
    <span class="label">Add</span>
  </button> &nbsp; &nbsp;
  <button *ngIf="isAddComment" class="alignment" mat-raised-button [disabled]="commentsLoading || isLoading"
    style="text-transform: uppercase" (click)="isAddComment = !isAddComment" color="accent">
    Cancel
  </button>
  <br>
  <br>

  <span class="error">{{ error }}</span>

  <br />
  <!-- <span *ngIf="!commentsLoading && commentData.length == 0">No Comments</span> -->
</form>



// WEBPACK FOOTER //
// ./src/app/main/content/comments/comments.component.html